import { render, staticRenderFns } from "./WithSummaryCard.vue?vue&type=template&id=3dd7971c&scoped=true"
import script from "./WithSummaryCard.vue?vue&type=script&lang=js"
export * from "./WithSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./WithSummaryCard.vue?vue&type=style&index=0&id=3dd7971c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7971c",
  null
  
)

export default component.exports